import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { NoteContainer } from './subcomponents';
const DisclaimerNote = () => {
    return (_jsx(NoteContainer, { children: _jsx(Trans, { i18nKey: "disclaimer.note", children: translate('disclaimer.note') }) }));
};
export default DisclaimerNote;
